import { render, staticRenderFns } from "./Balance.vue?vue&type=template&id=9864654c&scoped=true&lang=pug"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.vue?vue&type=style&index=0&id=9864654c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9864654c",
  null
  
)

export default component.exports